<template>
  <md-outlined-text-field
    v-if="outlined"
    :class="{ 'error-field': props.error }"
    :label="props.label"
    :value="props.modelValue"
    :disabled="props.disabled"
    :type="props.type"
    :autocomplete="props.autocomplete"
    :name="props.name"
    :inputmode="props.inputmode"
    :error="props.error"
    @change="e => emit('change', e)"
    @input="
      e => emit('update:modelValue', e.target.value)
    "></md-outlined-text-field>
  <md-filled-text-field
    v-else
    :class="{ 'error-field': props.error }"
    :label="props.label"
    :placeholder="props.placeholder"
    :value="props.modelValue"
    :disabled="props.disabled"
    :type="props.type"
    :autocomplete="props.autocomplete"
    :name="props.name"
    :inputmode="props.inputmode"
    :maxLength="props.maxLength"
    :error="props.error"
    supporting-text=""
    @change="e => emit('change', e)"
    @input="
      e => emit('update:modelValue', e.target.value)
    "></md-filled-text-field>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (event: 'update:modelValue', payload: string): void;
  (event: 'change', payload: Event): void;
}>();

const props = withDefaults(
  defineProps<{
    label?: string;
    placeholder?: string;
    modelValue: string;
    autocomplete?: string;
    inputmode?: string;
    name?: string;
    maxLength?: number;
    disabled?: boolean;
    outlined?: boolean;
    type?: HTMLInputElement['type'];
    error?: boolean;
  }>(),
  {
    inputmode: '',
    placeholder: '',
    label: '',
    name: '',
    autocomplete: '',
    outline: false,
    disabled: false,
    maxLength: -1,
    type: 'text',
    outlined: false,
    error: false,
  }
);
</script>

<style scoped>
.error-field {
  --md-outlined-text-field-outline-color: #d32f2f !important;
  --md-outlined-text-field-focus-outline-color: #d32f2f !important;
  --md-outlined-text-field-hover-outline-color: #d32f2f !important;
  --md-filled-text-field-active-indicator-color: #d32f2f !important;
  --md-filled-text-field-focus-active-indicator-color: #d32f2f !important;
  --md-filled-text-field-hover-active-indicator-color: #d32f2f !important;
}
</style>
